function WhyDifferent() {
  return (
    <section className="bg-black text-white py-24 px-6 md:px-20 flex justify-center">

      <div className="w-full max-w-7xl">

        {/*  HEADING */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <span className="border border-green-400 text-green-400 px-4 py-1 rounded-full text-sm bg-green-400/10">
              ⚡ Why Choose?
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold">
            Why Choose<span className="text-green-400"> Printezz</span> ?
          </h2>

          <p className="text-gray-400 mt-3">
            A smarter way compared to traditional & outdated systems
          </p>
        </div>

        {/*  3 CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

          {/*  TRADITIONAL */}
          <div className="bg-black/40 border border-red-500/30 rounded-2xl p-6 
          hover:border-red-400 transition shadow-[0_0_20px_rgba(255,0,0,0.2)]">

            <h3 className="text-xl font-semibold mb-6 text-red-400">
              Traditional Print Shops
            </h3>

            <ul className="space-y-4 text-gray-400">
              <li className="flex gap-3"><span className="text-red-400">✖</span> Limited Working Hours</li>
              <li className="flex gap-3"><span className="text-red-400">✖</span> Long queues and delays</li>
              <li className="flex gap-3"><span className="text-red-400">✖</span> Files visible to staff</li>
              <li className="flex gap-3"><span className="text-red-400">✖</span> Manual handling required</li>
              <li className="flex gap-3"><span className="text-red-400">✖</span> Slower process</li>
            </ul>
          </div>

          {/* ⚠️ GENERIC SYSTEMS */}
          <div className="bg-black/40 border border-yellow-400/30 rounded-2xl p-6 
          hover:border-yellow-400 transition shadow-[0_0_20px_rgba(255,200,0,0.2)]">

            <h3 className="text-xl font-semibold mb-6 text-yellow-400">
              Generic Automated Systems
            </h3>

            <ul className="space-y-4 text-gray-300">
              <li className="flex gap-3"><span className="text-yellow-400">✔</span> Limited compatibility </li>
              <li className="flex gap-3"><span className="text-yellow-400">✔</span> Proprietary firmware dependency</li>
              <li className="flex gap-3"><span className="text-yellow-400">✔</span> Multi-step complex process</li>
              <li className="flex gap-3"><span className="text-yellow-400">✔</span> Otp required for Printing</li>
              <li className="flex gap-3"><span className="text-yellow-400">✔</span> Slower printing</li>
            </ul>
          </div>

          {/* ✅ PRINTEZZ (HIGHLIGHTED) */}
          <div className="bg-green-400/10 border border-green-400/40 rounded-2xl p-6 
          shadow-[0_0_40px_#00ff9f30] hover:scale-[1.02] transition">

            <h3 className="text-xl font-semibold mb-6 text-green-400">
              Printezz
            </h3>

            <ul className="space-y-4 text-white">
              <li className="flex gap-3"><span className="text-green-400">✔</span> One QR for both printing and Payment</li>
              <li className="flex gap-3"><span className="text-green-400">✔</span> Easily Scalable with any type of printer</li>
              <li className="flex gap-3"><span className="text-green-400">✔</span> Fully automated with your phone</li>
              <li className="flex gap-3"><span className="text-green-400">✔</span> Fast 24x7 seamless experience</li>
              <li className="flex gap-3"><span className="text-green-400">✔</span> Secure & auto-deleted files</li>
            </ul>

          </div>

        </div>

      </div>
    </section>
  );
}

export default WhyDifferent;